import { render, staticRenderFns } from "./AccionVerReferencias.vue?vue&type=template&id=7c979abe&scoped=true&"
import script from "./AccionVerReferencias.vue?vue&type=script&lang=js&"
export * from "./AccionVerReferencias.vue?vue&type=script&lang=js&"
import style0 from "./AccionVerReferencias.vue?vue&type=style&index=0&id=7c979abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c979abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c979abe')) {
      api.createRecord('7c979abe', component.options)
    } else {
      api.reload('7c979abe', component.options)
    }
    module.hot.accept("./AccionVerReferencias.vue?vue&type=template&id=7c979abe&scoped=true&", function () {
      api.rerender('7c979abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionVerReferencias.vue"
export default component.exports